import {
	CourseOption,
	ExistingCourse,
	Tree,
	UploadMode,
} from "@/types/taxonomies";

export enum ActionTypes {
	HANDLE_FILE_CHECKED_SUCCESSFULLY = "HANDLE_FILE_CHECKED_SUCCESSFULLY",
	FILE_ERRORS = "FILE_ERRORS",
	SET_COURSE_DETAILS = "SET_COURSE_DETAILS",
	SET_PRODUCTION_ID = "SET_PRODUCTION_ID",
	SET_COURSES_TYPE = "SET_COURSES_TYPE",
	SET_UPLOAD_MODE = "SET_UPLOAD_MODE",
	SET_TARGET_COURSES = "SET_TARGET_COURSES",
	SET_SELECTED_COURSES = "SET_SELECTED_COURSES",
	RESET = "RESET",
	RESET_FILE = "RESET_FILE",
	HANDLE_LOADING = "HANDLE_LOADING",
}

type Option = { label: string; value: string };

export type Validations = { row_number: string; errors: string[] };
export type Providers = { name: string; id: string };
export type Categories = { name: string; id: string };
export type AgeGroup = Option;
export type Semester = Option;

export type Action =
	| {
			type: ActionTypes.HANDLE_FILE_CHECKED_SUCCESSFULLY;
			payload: { data: Tree[]; fileName: string };
	  }
	| {
			type: ActionTypes.FILE_ERRORS;
			payload: {
				validations: Validations[];
				fileName: string;
				errorMessages?: string[];
			};
	  }
	| {
			type: ActionTypes.SET_COURSE_DETAILS;
			payload: {
				providers: Providers[];
				categories: Categories[];
				ageGroups: AgeGroup[];
				selectedProviders: string[];
				selectedCategory: string;
				selectedAgeGroups: string[];
				isSettingAgeGroups: boolean;
				isDeci: boolean;
				selectedSemester: string;
			};
	  }
	| {
			type: ActionTypes.SET_PRODUCTION_ID;
			payload: {
				data: Tree[];
			};
	  }
	| {
			type: ActionTypes.SET_COURSES_TYPE;
			payload: {
				courseType: string;
			};
	  }
	| {
			type: ActionTypes.SET_UPLOAD_MODE;
			payload: {
				uploadMode: UploadMode;
			};
	  }
	| {
			type: ActionTypes.SET_TARGET_COURSES;
			payload: {
				targetCourses: Record<string, ExistingCourse>;
			};
	  }
	| {
			type: ActionTypes.SET_SELECTED_COURSES;
			payload: {
				selectedCourses: CourseOption[];
			};
	  }
	| {
			type: ActionTypes.HANDLE_LOADING;
			payload: {
				loading: boolean;
			};
	  }
	| { type: ActionTypes.RESET }
	| { type: ActionTypes.RESET_FILE };

export type State = {
	isFileChecked: boolean;
	errors: Validations[];
	data: Tree[];
	providers: Providers[];
	categories: Categories[];
	ageGroups: AgeGroup[];
	selectedProviders: string[];
	selectedCategory: string;
	selectedAgeGroups: string[];
	isSettingAgeGroups: boolean;
	courseType: string;
	fileName: string;
	errorMessages: string[];
	isDeci: boolean;
	loading: boolean;
	selectedSemester: string;
	uploadMode: UploadMode;
	/** Courses the admin picked to add to, before the file is checked. */
	selectedCourses: CourseOption[];
	/** Courses the uploaded file matched, keyed by their platform id. */
	targetCourses: Record<string, ExistingCourse>;
};

export type Dispatch = (action: Action) => void;

export type TaxonomiesProviderProps = { children: React.ReactNode };
